import React from "react";
import {
  Button,
    createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  
  DialogTitle,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";


const theme = createTheme()
const useStyles = makeStyles(()=>({
    actionBtn:{
        width:'50%',
        padding:'1rem 0',
        fontWeight:'bold',
        [theme.breakpoints.down('md')]:{
            width:'80%'
        },
        [theme.breakpoints.down('xs')]:{
            width:'100%'
        },

    }
}))


const MainCardModal = (props) => {
const {t} = useTranslation()
const classes  = useStyles()
  const handleClose =()=>{
       props.setOpen(false)
      
  } 
  
  return (
    <div >
      <Dialog
        fullWidth
        maxWidth={'md'}
        open={props.open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('yuzlenmani saylan')}
        </DialogTitle>
        <DialogContent className='t-center'>
          
            <Button className={classes.actionBtn} onClick={()=>{
                handleClose()
            }} size='large' color='info' variant='contained'>{t('yuzlenmani doretmek')}</Button>
            <br/>
            <br/>
            <Button className={classes.actionBtn} onClick={()=>{
                 handleClose();props.handleOpenCheckOrder() 
            }} size='large' variant='contained'>{t('doredilen yuzlenme')}</Button>
        </DialogContent>
        <DialogActions>
          <Button color='error' size='large'  onClick={handleClose}>{t('yapmak')}</Button>
          
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MainCardModal;
